import { Dispatch, SetStateAction, useContext } from "react";

import { Select, Tooltip } from "antd";
import { AppContext } from "App";
import { GoPlus } from "react-icons/go";
import { AccountDetails } from "types/banking";
import "styles/questionnaire/bankAccountSelector.less";

interface BankAccountSelectorProps {
    connectedBankAccounts: AccountDetails[];
    selectedBankAccount?: string;
    setSelectedBankAccount: Dispatch<SetStateAction<string | undefined>>;
}

export default function BankAccountSelector({ connectedBankAccounts, selectedBankAccount, setSelectedBankAccount }: BankAccountSelectorProps) {
    const { isMobile } = useContext(AppContext);
    const manualOption = {
        value: "manual",
        label: (<div className="bank-account-selector__input__input-text">Add bank details manually</div>),
    };

    const options = connectedBankAccounts.map(account => {
        const characterLimit = isMobile ? 25 : 45;
        const labelText = `${account.institutionDetails.name}${account.accountName ? " - " : ""}${account.accountName}`;
        return ({
            value: account._id,
            label: (
                <>
                    <Tooltip placement="top" title={labelText}>
                        <div className="bank-account-selector__input__input-text">{labelText.slice(0, characterLimit).trim()}{labelText.length > characterLimit ? "..." : ""}</div>
                    </Tooltip>
                </>
            ),
        });
    });

    const handleChange = (value: string) => {
        setSelectedBankAccount(value);
    };

    return (
        <div className="bank-account-selector__container">
            <span>Select a bank account</span>
            <Select
                defaultValue={selectedBankAccount}
                onChange={handleChange}
                options={[manualOption, ...options]}
                className="bank-account-selector__input"
                optionRender={option => {
                    if (option.value === "manual") return <div className="bank-account-selector__dropdown__manual-option"><GoPlus />{manualOption.label}</div>;
                    const account = connectedBankAccounts.find(account => account._id === option.value);
                    if (!account) return null;
                    return (
                        <div className="bank-account-selector__dropdown">
                            <div className="bank-account-selector__dropdown__divider" />
                            <div className="bank-account-selector__dropdown__account">
                                <img
                                    src={account.logo}
                                    alt={""}
                                    className="bank-account-selector__dropdown__account__account-logo"
                                />
                                <span className="bank-account-selector__dropdown__account__account-details">
                                    <span className="bank-account-selector__dropdown__account__account-name">{account.accountName}</span>
                                    <span className="bank-account-selector__dropdown__account__account-number">{account.accountNumber ?? account.iban}</span>
                                    <span className="bank-account-selector__dropdown__account__account-info">
                                        Current • {Intl.NumberFormat("en-UK", { style: "currency", currency: account.currencyCode ?? "GBP" }).format(account.balance ?? 0)} • {account.currencyCode}
                                    </span>
                                </span>
                            </div>
                        </div>
                    );
                }}
            />
        </div>
    );
}
